// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import listUserCues from "./listUserCues"
import createUserCue from "./createUserCue"
import { Action } from "redux"
import type { RootState } from "../../../app/store"

export default combineEpics<Action, Action, RootState, unknown>(
  listUserCues,
  createUserCue,
)
